module.exports = __webpack_public_path__ + "static/invoker-04-ead0b9dceeafa6dd485820bba5960015.png";